<script setup lang="ts"></script>

<template>
  <div class="flex justify-center items-center h-screen">
    <router-view />
  </div>
</template>
